// 平台标识列表，暂时前端维护
export const platformList = [
  {
    platform_id: 'dot',
    name: 'DOT轻任务平台',
    path: '/wel/index',
  },
  {
    platform_id: 'trm',
    name: '资源运营平台',
    path: '/m_op',
  },
  {
    platform_id: 'bi',
    name: '数据中台',
    path: '/m_op',
  },
  {
    platform_id: 'system',
    name: '系统管理',
    path: '/wel/index',
  },
];

// 默认平台标识
export const defaultPlatform = 'dot';

// 平台标识缓存key
export const localPlatformKey = '__login_platform';

// dot-admin的平台标识
export const dotAdminPlatform =
  sessionStorage.getItem(localPlatformKey) || defaultPlatform;
